export default {
  showOutcomeNameOnButton: false,
  showMatchDataInRow: false,
  hideMainButtonOnPrematchShowcase: false,
  breadcrumbPrematchType: 'default',
  breadcrumbLiveType: 'default',
  marketsGroupLayout: 'default',
  mainMarketButtonDisabled: false,
  oddsButtonType: 'default',
  liveEventListPosition: 'left-component',
  customCssPath: 'style',
  betCarouselType: 'default',
  useExternalTree: false,
  useGenericSkinListener: false,
  useModalCart: false,
  bannerMatchEventDetail: 'default',
  scrollingLiveEventsWidget: 'default',
  maxLiveMarketsInPreview: null,
  showBestPlayed: true,
  version: 1
};
